import { DokuLinkEntry, DokuLinkSearchResponse } from '../core/gb-api';
import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GbPrintService } from '../core/services/app-print.service';
import { ComponentLocationStrategy } from '../shared/services/location-strategy/component-location-strategy';
import { DokulinkLocationStrategy } from '../shared/services/location-strategy/dokulink-location-strategy';
import { ComparatorService } from '../shared/services/comparator-service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { DokulinkItem } from '../shared/components/dokulink/dokulinkItem';
import { sanatizedSaveAs } from '../shared/functions/file.functions';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-dokulink-modal',
  templateUrl: './dokulink-modal.component.html',
  styleUrls: ['./dokulink-modal.component.scss'],
  providers: [{ provide: ComponentLocationStrategy, useClass: DokulinkLocationStrategy }],
  imports: [TranslatePipe]
})
export class DokulinkModalComponent implements OnDestroy {
  @Input()
  dokulinkItem: DokulinkItem;

  @Input()
  modalTitle;

  private subscription: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private printService: GbPrintService,
    private comperatorService: ComparatorService
  ) {
    keysToTranslate<string>(['BelegeZuGrundbuchgeschäft', 'belegeZu', 'eBelege']);
  }

  sort(doku: DokuLinkSearchResponse): DokuLinkSearchResponse {
    doku.dokuLinks.sort((a, b) => this.comperatorService.translatedStringComparator(a.dokumentName, b.dokumentName));
    doku.egvtDokuLinks.sort((a, b) => this.comperatorService.translatedStringComparator(a.dokumentName, b.dokumentName));
    return doku;
  }

  decode(uri: string) {
    if (!uri) {
      return '';
    }
    return decodeURI(uri);
  }

  getDokument(link: DokuLinkEntry) {
    window.open(link.dokuLink);
  }

  loadEgvtDokument(link: DokuLinkEntry) {
    this.subscription.add(
      this.printService.getEgvtDokument(link.dokuLink).subscribe((data) => {
        let file: Blob & { name?: string };
        file = new Blob([data], { type: 'application/pdf' });
        file.name = link.dokumentName + '.pdf';
        sanatizedSaveAs(file);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
